import React from 'react';
import SocialIcon from './SocialIcon';
import { CONTACT_INFO, SOCIAL_LINKS } from '../data';

export default function TopStrip() {
  return (
    <div style={{ background:'linear-gradient(135deg,#E8315B 0%,#7B52AB 50%,#4BB8E8 100%)', padding:'9px 0', position:'relative', zIndex:1001 }}>
      <div className="container">
        <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', flexWrap:'wrap', gap:8 }}>
          <div style={{ display:'flex', alignItems:'center', gap:20, flexWrap:'wrap' }}>
            <a href={`mailto:${CONTACT_INFO.email}`} style={{ display:'flex', alignItems:'center', gap:7, fontSize:'.79rem', fontWeight:600, color:'rgba(255,255,255,.92)' }}>
              <svg width="13" height="13" viewBox="0 0 24 24" fill="rgba(255,255,255,.8)"><path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/></svg>
              <span>{CONTACT_INFO.email}</span>
            </a>
            <a href="tel:+917808707393" style={{ display:'flex', alignItems:'center', gap:7, fontSize:'.79rem', fontWeight:600, color:'rgba(255,255,255,.92)' }}>
              <svg width="13" height="13" viewBox="0 0 24 24" fill="rgba(255,255,255,.8)"><path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/></svg>
              <span>{CONTACT_INFO.phone}</span>
            </a>
          </div>
          <div style={{ display:'flex', alignItems:'center', gap:7 }}>
            {SOCIAL_LINKS.map(s => (
              <SocialIcon key={s.icon} icon={s.icon} url={s.url} name={s.name} size={27} radius={7} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
